import React from "react";
import theLoanProcess from "../../PicesForPages/TheLoanProcess.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function TheLoanProcess() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={theLoanProcess}
          alt="tlpImage"
          className="background-video theLoanProcessImage"
        />
        <div className="purchasetopBox TheLoanProcessPageTopBox">
          {/* The existing Purchase span */}
          <span>The Loan Process</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftHeader">Pre-qualification</span>
            <span className="purchaseBottomLeftContent">
              Before the actual loan process begins, pre-qualification takes
              place. The lender collects details about your income and debts to
              estimate how much house you can afford.
            </span>
            <span className="purchaseBottomLeftContent">
              It's advisable to understand your budget for a home before
              starting your search. For those refinancing, pre-qualification
              helps evaluate if refinancing is beneficial.
            </span>

            <span className="purchaseBottomLeftHeader">Application</span>
            <span className="purchaseBottomLeftContent">
              The loan process starts with the application, which happens after
              selecting a property to purchase or deciding to refinance an
              existing mortgage. You fill out a mortgage application for a
              specific loan program and provide all necessary documents. At this
              stage, fees and down payment options are discussed. Within three
              days, the loan officer provides a Good Faith Estimate (GFE) and a
              Truth-In-Lending Disclosure (TIL), detailing the loan's rates and
              estimated costs.
            </span>

            <span className="purchaseBottomLeftHeader">
              Processing of your Estimated Loan
            </span>
            <span className="purchaseBottomLeftContent">
              The lender usually submits your application to an automated
              underwriting system to determine the required documentation for
              loan approval. Sometimes, the application is manually
              underwritten.
            </span>
            <span className="purchaseBottomLeftContent">
              The lender's processor verifies your employment, debts, and
              payment history by reviewing credit reports and other documents.
              If there are issues like late payments or judgments, the processor
              will ask you for explanations. They also review the appraisal and
              survey for any property concerns that might affect loan approval,
              compiling a complete application package for the underwriter.
            </span>

            <span className="purchaseBottomLeftHeader">Underwriting</span>
            <span className="purchaseBottomLeftContent">
              The underwriter assesses whether the processor's package meets the
              lender's standards. If more details are needed, the loan enters
              "suspense," and additional documentation will be requested from
              you.
            </span>
            <span className="purchaseBottomLeftContent">
              Once approved, the lender issues a conditional commitment,
              arranges for title insurance, helps clear conditions, and
              schedules the closing. Conditions may relate to credit, income, or
              property issues identified during processing and underwriting.
            </span>

            <span className="purchaseBottomLeftHeader">Closing</span>
            <span className="purchaseBottomLeftContent">
              After all conditions are satisfied and the lender gives full loan
              approval, the closing takes place. The lender provides funds via
              cashier's check, draft, or wire transfer to the closing agent, who
              then disburses the funds, completing the property title transfer.
              This finalizes the loan process, enabling you to refinance or
              purchase the house under the lender's terms. The location of the
              closing varies by state and may occur at a closing attorney's
              office, title or escrow company, or even your home.
            </span>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://themortgageist.my1003app.com/2692605/register/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default TheLoanProcess;
